import Vue from "vue";
import VueLazyload from "vue-lazyload";
import PortalVue from "portal-vue";
import VueMq from "vue-mq";
import VueScrollTo from "vue-scrollto";
import VTooltip from "v-tooltip";
import VScrollLock from "v-scroll-lock";
import Vuelidate from "vuelidate";
import { createApp } from "./main";

Vue.use(VueLazyload, {
  lazyComponent: true,
  observer: true,
  observerOptions: {
    rootMargin: `${document.documentElement.clientHeight}px 0px`,
  },
});
Vue.use(PortalVue);
Vue.use(VueMq, {
  breakpoints: {
    "size-sm": 768,
    "size-md": 1024,
    "size-lg": 1256,
    "size-xl": 1344,
    "size-xxl": Infinity,
  },
  defaultBreakpoint: "size-xxl",
});
Vue.use(VueScrollTo, {
  duration: 500,
  offset: -50,
});
Vue.use(VTooltip);
Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
    allowTouchMove: (el) => el.closest(".multiselect__content-wrapper"),
  },
});
Vue.use(Vuelidate);

const { app, store } = createApp();

if (window.__TOUR_DETAL_INITIAL_STATE__) {
  const newState = {...store.state};
  newState.tours = window.__TOUR_DETAL_INITIAL_STATE__.tours;
  newState.reviews = window.__TOUR_DETAL_INITIAL_STATE__.reviews;
  store.replaceState(newState);

}

app.$mount("#serp-detail");
